import { useState } from "react";
import "./DropdownMenu.css";
import { ROUTES } from "../Resources/routes";
import useScrollOrNavigate from "./useScrollOrNavigate";

export default function DropdownMenu({ label, items, link, pagePath }) {
    const [open, setOpen] = useState(false);
    const hasDropdown = items && items.length > 0;
    const handleScrollOrNavigate = useScrollOrNavigate();

    return (
        <div
            className={`dropdown-wrapper ${open ? "open" : ""}`}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            <a
                href={link}
                className={
                    pagePath === link.split("/")[2] || (link.split("/")[2] === "" && pagePath === ROUTES.HOME)
                        ? "current"
                        : ""
                }
            >
                {label}
                {hasDropdown && <i className="icon ion-chevron-down arr-d"></i>}
            </a>

            {hasDropdown && (
                <div className="dropdown-items">
                    {items.map((item) => (
                        <span key={item.id} onClick={() => handleScrollOrNavigate(item.id, link)}>
                            {item.label}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
}
